import {fuzzyMatchRegex} from '@wandb/weave/common/util/fuzzyMatch';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, ButtonSizes, ButtonVariants} from '@wandb/weave/components';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useMemo, useState} from 'react';

import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';
import {BoundingBoxesForMediaKey} from './BoundingBoxesForMediaKey';
import {ConfidenceSlider} from './ConfidenceSlider';

export const BoundingBoxes = () => {
  const {allBoxes, sliderRanges, unsetConfigField, configWithoutDefaults} =
    useMediaSettingsDrawerContext();
  const [boxSearchQuery, setBoxSearchQuery] = useState('');
  const boxQueryRegex = useMemo(
    () => fuzzyMatchRegex(boxSearchQuery),
    [boxSearchQuery]
  );

  return (
    <div className="flex flex-col">
      <div className="mb-8 flex justify-between">
        <TextField
          dataTest="bounding-box-search-input"
          value={boxSearchQuery}
          onChange={setBoxSearchQuery}
          icon="search"
          placeholder="Search"
        />
        {configWithoutDefaults.boundingBoxConfig != null && (
          <Button
            aria-label="Reset to parent"
            icon="randomize-reset-reload"
            onClick={() => {
              unsetConfigField('boundingBoxConfig');
            }}
            size={ButtonSizes.Medium}
            tooltip="Reset to parent"
            variant={ButtonVariants.Ghost}
          />
        )}
      </div>
      {sliderRanges &&
        Object.keys(sliderRanges).map(key => (
          <ConfidenceSlider sliderKey={key} key={key} />
        ))}
      {Object.keys(allBoxes).map(mediaKey => (
        <BoundingBoxesForMediaKey
          mediaKey={mediaKey}
          key={mediaKey}
          boxQueryRegex={boxQueryRegex}
        />
      ))}
    </div>
  );
};
